<template>
  <div class="product-form">
    <h2>Edit Product</h2>
    <form @submit.prevent="updateProduct">
      <div class="form-group">
        <label for="title">Title</label>
        <input v-model="form.title" type="text" id="title" required/>
      </div>

      <div class="form-group">
        <label for="type">Type</label>
        <input v-model="form.type" type="text" id="type"/>
      </div>

      <div class="form-group">
        <label for="status">Status</label>
        <select v-model="form.status" id="status">
          <option value="">Select Status</option>
          <option v-for="status in productStatuses" :key="status" :value="status">{{ status }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="subcategory">Subcategory</label>
        <select v-model="form.subcategory" id="subcategory">
          <option value="">Select Subcategory</option>
          <option v-for="subcategory in subcategories" :key="subcategory.id" :value="subcategory.id">
            {{ subcategory.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="components">Components</label>
        <!--        <textarea v-model="form.components" id="components" rows="4"></textarea>-->
        <codemirror-editor-vue3
            v-model:value="form.components"
            :options="editorOptions"
            placeholder="Enter HTML content here..."
            :height="400"
        />
      </div>

      <div class="form-group">
        <label for="tags">Tags</label>
        <input v-model="form.tags" type="text" id="tags" placeholder="Comma-separated tags"/>
      </div>

      <div class="form-group">
        <label for="image">Product Image</label>
        <input type="file" @change="handleFileUpload" id="image"/>
      </div>

      <button type="submit">Update Product</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import {ref, onMounted} from "vue";
import CodemirrorEditorVue3 from "codemirror-editor-vue3";
import "codemirror/addon/display/placeholder.js";
import "codemirror/mode/javascript/javascript.js"; // Adjust to mode if you want HTML mode
import "codemirror/theme/dracula.css"; // Theme for the editor


export default {
  name: "ProductUpdateView",
  components: {CodemirrorEditorVue3},
  props: {
    productId: {
      type: Number,
      required: true,
    }
  },
  setup(props) {
    const form = ref({
      title: "",
      type: "",
      status: "",
      subcategory: "",
      components: "",
      tags: "",
      image: null,  // Initialize as null if no new image
    });

    // Handle file selection
    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        form.value.image = file;
      }
    };
    const editorOptions = {
      mode: "text/html", // Language mode for HTML
      theme: "dracula", // Theme
      lineNumbers: true,
      tabSize: 2,
    };
    const productStatuses = ["POPULAR", "NEW", "UPCOMING"];
    const subcategories = ref([]);

    // Fetch product details for update
    onMounted(() => {
      axios
          .get(`/dashboard/products/${props.productId}/`)  // Assuming this is the endpoint for fetching the product details
          .then((response) => {
            const product = response.data;
            form.value = {
              title: product.title,
              type: product.type,
              status: product.status,
              subcategory: product.subcategory.id,
              components: product.components,
              tags: product.tags,
              image: null,  // Assuming image URL is returned
            };
          })
          .catch((error) => {
            console.error("Error loading product:", error);
          });

      // Fetch subcategories
      axios
          .get("/dashboard/subcategories/")
          .then((response) => {
            subcategories.value = response.data;
          })
          .catch((error) => {
            console.error("Error loading subcategories:", error);
          });
    });


    // Update product
    // Submit form with Axios
    const updateProduct = () => {
      const formData = new FormData();
      formData.append("title", form.value.title);
      formData.append("type", form.value.type);
      formData.append("status", form.value.status);
      formData.append("subcategory", form.value.subcategory);
      formData.append("components", form.value.components);
      formData.append("tags", form.value.tags);

      // Check if an image file is set and append it
      if (form.value.image) {
        formData.append("image", form.value.image);
      }

      axios
          .put(`/dashboard/products/${props.productId}/`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response)
            alert("Product updated successfully!");
          })
          .catch((error) => {
            console.error("Error updating product:", error);
          });
    };
    return {
      form,
      productStatuses,
      subcategories,
      editorOptions,
      handleFileUpload,
      updateProduct,
    };
  },
};
</script>

<style scoped>
.product-form {
  max-width: 500px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  font-weight: bold;
}

input,
textarea,
select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  box-sizing: border-box;
}

button {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
}

button:hover {
  background-color: #45a049;
}
</style>
